'use strict';

var novicell = novicell || {};

novicell.imageMap = novicell.imageMap || new function () {
    const imageMaps = document.querySelectorAll('.js-image-map');
    const imageDna = document.querySelectorAll('.js-image-map-dna');
    let dimsMustBeClosed = false;

    this.init = function () {
        if (!imageMaps) {
            return;
        }
        for (let i = 0; i < imageMaps.length; i++) {
            const imageMapElm = imageMaps[i];
            const imageMapPoints = imageMapElm.querySelectorAll('.js-image-map-point');
            const imageMapRightBorder = imageMapElm.getBoundingClientRect().left + outerWidth(imageMapElm);
            
            imageMapElm.closest(".grid-section__cell").style.flexDirection = 'row';
            
            for (let p = 0; p < imageMapPoints.length; p++) {
                const speechBubble = imageMapPoints[p].getElementsByClassName('image-map-point__text')[0];
                var speechBubbleWidth = +window.getComputedStyle(speechBubble, null).getPropertyValue("width").replace('px','');
                const pointElm = imageMapPoints[p];
                const pointElmWidth = outerWidth(speechBubble);

                const pointRightBorder = pointElm.getBoundingClientRect().left + speechBubbleWidth;
                const pointIconWidth = outerWidth(pointElm.querySelector('.image-map-point__icon'));
                if(pointRightBorder > imageMapRightBorder) {
                    pointElm.classList.add('image-map-point--turn-left');
                }

                // console.log('Point: ' + pointRightBorder);

                pointElm.addEventListener('mouseover', function () {
                    pointElm.querySelector('.image-map-point__text').style.display = 'block';
                });

                pointElm.addEventListener('mouseout', function () {
                    pointElm.querySelector('.image-map-point__text').style.display = 'none';
                });
            }
        }

        if (!imageDna) {
            return;
        }

        document.addEventListener('click', function(event) {
            if(dimsMustBeClosed){
                var dimsIsShowen = document.getElementsByClassName('image-map-point__text--show')[0];
                
                if(dimsIsShowen) {
                    dimsIsShowen.classList.remove("image-map-point__text--show");
                }
                dimsMustBeClosed = false;
            }else{
                dimsMustBeClosed = true;
            }
        });

        for (let i = 0; i < imageDna.length; i++) {
            const imageMapElm = imageDna[i];
            const imageMapPoints = imageMapElm.querySelectorAll('.js-image-map-point-dna');

            imageMapElm.closest(".grid-section__cell").style.flexDirection = 'row';


            for (let p = 0; p < imageMapPoints.length; p++) {
                const pointElm = imageMapPoints[p];
                const popup = pointElm.nextElementSibling;

                console.log(pointElm.nextElementSibling);
                
                pointElm.addEventListener('click', function () {
                    if(!dimsMustBeClosed){
                        dimsMustBeClosed = false;
                        popup.classList.add('image-map-point__text--show');
                    }
                });
            }
        }
    };

    function outerWidth(el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
    }
}();